import labelInputMixin from "../../_mixin";
export default {
  name: "LabelSelect",
  mixins: [labelInputMixin],
  methods: {
    renderInput(h, data) {
      return h(
        "el-select",
        {
          ...data,
          style: { ...data.style, width: "100%" }
        },
        this.$slots.default
      );
    }
  }
};
